import React from "react";
import { Link } from "react-router-dom";
import logo from "../assets/IMG-20251225-WA0344.png";

function Navbar() {
  return (
    <nav style={styles.nav}>
      <div style={styles.logoBox}>
        <img src={logo} alt="Unblemished Advocacy Logo" style={styles.logo} />
        <h2 style={styles.logoText}>Unblemished Advocacy</h2>
      </div>

      <div style={styles.links}>
        <Link to="/" style={styles.link}>Home</Link>
        <Link to="/volunteer" style={styles.link}>Volunteer</Link>
        <Link to="/donate" style={styles.link}>Donate</Link>
        <Link to="/essay" style={styles.link}>Essay</Link>
        <Link to="/articles" style={styles.link}>Articles</Link>
        <Link to="/contact" style={styles.link}>Contact</Link>
      </div>
    </nav>
  );
}

const styles = {
  nav: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "15px 20px",
    background: "#19195f",
    color: "white",
    flexWrap: "wrap",
  },
  logoBox: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
  },
  logo: {
    width: "91px",
    height: "100px",
    borderRadius: "50%",
  },
  logoText: {
    margin: 0,
    fontSize: "1.3rem", 
  },
  links: {
    display: "flex",
    gap: "13px",
    flexWrap: "wrap",
    overflow: "auto",
  },
  link: {
    fontSize: "clamp(12px, 2.5vw, 16px)",
    fontWeight: "bold",
    color: "white",
    textDecoration: "none",
    whiteSpace: "nowrap",
    flexShrink: 0,
    transition: "color 0.3s, transform 0.3s",
  }
};

export default Navbar;